import { AUTHORIZATION_HEADER } from '../../../../../src/authorization';
import { send } from '../../../../../src/network';
import { type TagList } from '../../../../../src/types/TagList';

export async function getTag(tagId: number) {
  return send<TagList>({
    path: `/api/v2/tags/${tagId}`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
